<template>
  <div :class="`customer customer-${design}`">
    
      <base-message v-if="auto_close"  class="mb_30"> Este pedido foi finalizado automaticamente. </base-message> 

    <div class="box-customer">
      <div class="customer-details d-flex justify-between align-center">
        <p class="customer-name">
          {{ name.length > 0 ? name : StringLanguage.customerNotAssigned }}
        </p>
        <div v-if="orderId" class="password">Senha {{ orderId }}</div>
      </div>
      <div v-if="phone" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-phone"></i></p>
        <p class="customer-address">{{ phone }}</p>
      </div>
      <div v-if="type" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-bell"></i></p>
        <p class="customer-address">Origem {{ (type === UserType.GESTAO || type === UserType.LOCAL) ? 'balcão' : type === UserType.FRONT ? 'loja online' : null }}</p>
      </div>
      <div v-if="orderTime" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-clock"></i></p>
        <p class="customer-payment">{{ orderTime }}</p>
      </div>
      <div v-if="address" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-map-marker-alt"></i></p>
        <p class="customer-address">{{ address }}</p>
      </div>
      <div v-if="email" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-envelope"></i></p>
        <p class="customer-address">{{ email }}</p>
      </div>
      <div v-if="birthday" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-birthday-cake"></i></p>
        <p class="customer-payment">{{ birthday }}</p>
      </div>
      <div v-if="payment" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-credit-card-blank"></i></p>
        <p class="customer-payment">{{ payment }}</p>
      </div>
      <div v-if="orderStatus" class="d-flex mt_15 align-center">
        <p class="icon-box"><i class="fal fa-receipt"></i></p>
        <p class="customer-payment">{{ orderStatus }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { Type as UserType } from "easyjs/lib/Schema/Account/User";
import VerifiedBadge from "@/containers/Users/VerifiedBadge";
import BaseMessage from "@/components/Message";

export default {
  props: {
    design: { type: String, default: "one" },
    name: { type: String, required: true, default: "" },
    phone: String,
    email: String,
    address: String,
    payment: String,
    birthday: String,
    orderStatus: String,
    orderTime: String,
    orderId: Number,
    type: String,
    auto_close:Boolean
  },
  data() {
    return {
      UserType,
    };
  },
  components: {
    VerifiedBadge,
    BaseMessage,
  },
};
</script>
<style scoped>
.customer {
  padding: 30px 0;
  font-size: 1.2em;
  position: relative;
  overflow: hidden;
  border-top: 2px dashed #ffffff17;
}
.customer .box-customer {
  border: 2px dashed #ffffff17;
  padding: 20px;
  background: #3e4145;
}
.customer.customer-one {
  color: #c9c9c9c6;
}
.customer.customer-two {
  color: white;
}
.customer-details {
  margin-bottom: 20px;
  border-bottom: 1px solid #ffffff1a;
  padding-bottom: 20px;
}
.customer-details .password {
  background: #424549;
  padding: 5px 10px;
  line-height: 17px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #aaaaaaed;
}
.customer-name {
  font-size: 18px;
  font-weight: bold;
  color: #aaaaaaed;
  line-height: 22px;
}
.customer-seal {
  position: absolute;
}
.customer-address,
.customer-payment {
  display: flex;
  margin-left: 10px;
  font-weight: 300;
  color: #aaaaaaed;
  font-size: 12px;
  line-height: 15px;
}
.icon-box {
  font-size: 15px;
  display: flex;
  color: #8c8c8c;
  width: 18px;
  justify-content: center;
  align-items: center;
}
</style>
